import { getApiBaseUrl as getConfiguredApiBaseUrl, getApiKey as getConfiguredApiKey, toMockErrorResponse, toMockResponse } from 'fake-db/apiConfig'
import Mock from '../mock'
import axios from 'axios.js'
const getApiBase = () => getConfiguredApiBaseUrl()
const getApiKey = () => getConfiguredApiKey()

Mock.onGet('/api/superadmin/dashboard').reply(async () => {
    try {
        const response = await axios.get(`${getApiBase()}/?apiKey=${getApiKey()}&route=superadmin/dashboard/get/`)
        return [200, response?.data || {}]
    } catch (e) {
        console.error('superadmin dashboard error', e)
        return [500, { message: 'Ошибка получения сводки суперадмина' }]
    }
})

Mock.onGet('/api/superadmin/clients').reply(async () => {
    try {
        const response = await axios.get(`${getApiBase()}/?apiKey=${getApiKey()}&route=superadmin/clients/get/`)
        return [200, response?.data || {}]
    } catch (e) {
        console.error('superadmin clients error', e)
        return [500, { message: 'Ошибка получения списка клиентов' }]
    }
})

Mock.onPost('/api/superadmin/clients/user/update').reply(async (config) => {
    try {
        const data = config?.data ? JSON.parse(config.data) : {}
        const response = await axios.post(
            `${getApiBase()}/?apiKey=${getApiKey()}&route=superadmin/clients/user/update/`,
            data || {}
        )
        return [200, response?.data || {}]
    } catch (e) {
        console.error('superadmin update user error', e)
        return [500, { message: 'Ошибка обновления пользователя' }]
    }
})

Mock.onGet('/api/superadmin/system').reply(async () => {
    try {
        const response = await axios.get(`${getApiBase()}/?apiKey=${getApiKey()}&route=superadmin/system/get/`)
        return [200, response?.data || {}]
    } catch (e) {
        console.error('superadmin system get error', e)
        return [500, { message: 'Ошибка получения системных настроек' }]
    }
})

Mock.onPost('/api/superadmin/system/save').reply(async (config) => {
    try {
        const data = config?.data ? JSON.parse(config.data) : {}
        const response = await axios.post(
            `${getApiBase()}/?apiKey=${getApiKey()}&route=superadmin/system/save/`,
            data || {}
        )
        return [200, response?.data || {}]
    } catch (e) {
        console.error('superadmin system save error', e)
        return [500, { message: 'Ошибка сохранения системных настроек' }]
    }
})

Mock.onPost('/api/system/migrations/apply').reply(async () => {
    try {
        return toMockResponse(await axios.post(
            `${getApiBase()}/?apiKey=${getApiKey()}&route=system/migrations/apply/`,
            {}
        ))
    } catch (e) {
        console.error('system migrations apply error', e?.response?.data || e?.message || e)
        return toMockErrorResponse(e, 'Ошибка обновления схемы')
    }
})

Mock.onPost('/api/superadmin/notifications/billing-expiry-test/send').reply(async (config) => {
    try {
        const data = config?.data ? JSON.parse(config.data) : {}
        const response = await axios.post(
            `${getApiBase()}/?apiKey=${getApiKey()}&route=superadmin/notifications/billing-expiry-test/send/`,
            data || {}
        )
        return [200, response?.data || {}]
    } catch (e) {
        console.error('superadmin billing expiry notification test error', e)
        return [500, { message: 'Ошибка отправки тестового уведомления' }]
    }
})

Mock.onPost('/api/superadmin/logs').reply(async (config) => {
    try {
        const data = config?.data ? JSON.parse(config.data) : {}
        const response = await axios.post(
            `${getApiBase()}/?apiKey=${getApiKey()}&route=superadmin/logs/get/`,
            data || {}
        )
        return [200, response?.data || {}]
    } catch (e) {
        console.error('superadmin logs error', e)
        return [500, { message: 'Ошибка получения логов суперадмина' }]
    }
})

Mock.onPost('/api/superadmin/logs/cleanup').reply(async (config) => {
    try {
        const data = config?.data ? JSON.parse(config.data) : {}
        const response = await axios.post(
            `${getApiBase()}/?apiKey=${getApiKey()}&route=superadmin/logs/cleanup/`,
            data || {}
        )
        return [200, response?.data || {}]
    } catch (e) {
        console.error('superadmin logs cleanup error', e)
        return [500, { message: 'Ошибка очистки логов суперадмина' }]
    }
})

Mock.onGet('/api/superadmin/billing/plans').reply(async () => {
    try {
        const response = await axios.get(`${getApiBase()}/?apiKey=${getApiKey()}&route=superadmin/billing/plans/get/`)
        return [200, response?.data || {}]
    } catch (e) {
        console.error('superadmin billing plans error', e)
        return [500, { message: 'Ошибка получения тарифов' }]
    }
})

Mock.onPost('/api/superadmin/billing/plan/save').reply(async (config) => {
    try {
        const data = config?.data ? JSON.parse(config.data) : {}
        const response = await axios.post(
            `${getApiBase()}/?apiKey=${getApiKey()}&route=superadmin/billing/plan/save/`,
            data || {}
        )
        return [200, response?.data || {}]
    } catch (e) {
        console.error('superadmin billing plan save error', e)
        return [500, { message: 'Ошибка сохранения тарифа' }]
    }
})

Mock.onGet('/api/superadmin/billing/subscriptions').reply(async () => {
    try {
        const response = await axios.get(`${getApiBase()}/?apiKey=${getApiKey()}&route=superadmin/billing/subscriptions/get/`)
        return [200, response?.data || {}]
    } catch (e) {
        console.error('superadmin billing subscriptions error', e)
        return [500, { message: 'Ошибка получения подписок' }]
    }
})

Mock.onPost('/api/superadmin/billing/subscription/assign').reply(async (config) => {
    try {
        const data = config?.data ? JSON.parse(config.data) : {}
        const response = await axios.post(
            `${getApiBase()}/?apiKey=${getApiKey()}&route=superadmin/billing/subscription/assign/`,
            data || {}
        )
        return toMockResponse(response)
    } catch (e) {
        console.error('superadmin billing assign error', e)
        return toMockErrorResponse(e, 'Ошибка назначения тарифа')
    }
})

Mock.onPost('/api/superadmin/billing/multibrand/preview').reply(async (config) => {
    try {
        const data = config?.data ? JSON.parse(config.data) : {}
        return toMockResponse(await axios.post(
            `${getApiBase()}/?apiKey=${getApiKey()}&route=superadmin/billing/multibrand/preview/`,
            data || {}
        ))
    } catch (e) {
        return toMockErrorResponse(e, 'Ошибка проверки лимита брендов')
    }
})

Mock.onPost('/api/superadmin/billing/denials').reply(async (config) => {
    try {
        const data = config?.data ? JSON.parse(config.data) : {}
        const response = await axios.post(
            `${getApiBase()}/?apiKey=${getApiKey()}&route=superadmin/billing/denials/get/`,
            data || {}
        )
        return [200, response?.data || {}]
    } catch (e) {
        console.error('superadmin billing denials error', e)
        return [500, { message: 'Ошибка получения отказов биллинга' }]
    }
})

Mock.onPost('/api/superadmin/billing/orders-addon/list').reply(async (config) => {
    try {
        const data = config?.data ? JSON.parse(config.data) : {}
        const response = await axios.post(
            `${getApiBase()}/?apiKey=${getApiKey()}&route=superadmin/billing/orders-addon/get/`,
            data || {}
        )
        return [200, response?.data || {}]
    } catch (e) {
        console.error('superadmin billing orders addon list error', e)
        return [500, { message: 'Ошибка получения докупок заказов' }]
    }
})

Mock.onPost('/api/superadmin/billing/orders-addon/add').reply(async (config) => {
    try {
        const data = config?.data ? JSON.parse(config.data) : {}
        const response = await axios.post(
            `${getApiBase()}/?apiKey=${getApiKey()}&route=superadmin/billing/orders-addon/add/`,
            data || {}
        )
        return [200, response?.data || {}]
    } catch (e) {
        console.error('superadmin billing orders addon add error', e)
        return [500, { message: 'Ошибка добавления пакета заказов' }]
    }
})

Mock.onGet('/api/superadmin/billing/orders-addon/packages').reply(async () => {
    try {
        const response = await axios.get(
            `${getApiBase()}/?apiKey=${getApiKey()}&route=superadmin/billing/orders-addon/packages/get/`
        )
        return [200, response?.data || {}]
    } catch (e) {
        console.error('superadmin billing orders addon packages get error', e)
        return [500, { message: 'Ошибка получения пакетов докупки' }]
    }
})

Mock.onPost('/api/superadmin/billing/orders-addon/packages/save').reply(async (config) => {
    try {
        const data = config?.data ? JSON.parse(config.data) : {}
        const response = await axios.post(
            `${getApiBase()}/?apiKey=${getApiKey()}&route=superadmin/billing/orders-addon/packages/save/`,
            data || {}
        )
        return [200, response?.data || {}]
    } catch (e) {
        console.error('superadmin billing orders addon packages save error', e)
        return [500, { message: 'Ошибка сохранения пакетов докупки' }]
    }
})

Mock.onPost('/api/superadmin/billing/wallet/topup/mock').reply(async (config) => {
    try {
        const data = config?.data ? JSON.parse(config.data) : {}
        const response = await axios.post(
            `${getApiBase()}/?apiKey=${getApiKey()}&route=superadmin/billing/wallet/topup/mock/`,
            data || {}
        )
        return [200, response?.data || {}]
    } catch (e) {
        console.error('superadmin billing wallet topup mock error', e)
        return [500, { message: 'Ошибка пополнения баланса клиента' }]
    }
})

Mock.onGet('/api/superadmin/billing/feature-bindings').reply(async () => {
    try {
        const response = await axios.get(`${getApiBase()}/?apiKey=${getApiKey()}&route=superadmin/billing/feature-bindings/get/`)
        return [200, response?.data || {}]
    } catch (e) {
        console.error('superadmin billing feature bindings get error', e)
        return [500, { message: 'Ошибка получения привязок модулей' }]
    }
})

Mock.onPost('/api/superadmin/billing/feature-bindings/save').reply(async (config) => {
    try {
        const data = config?.data ? JSON.parse(config.data) : {}
        const response = await axios.post(
            `${getApiBase()}/?apiKey=${getApiKey()}&route=superadmin/billing/feature-bindings/save/`,
            data || {}
        )
        return [200, response?.data || {}]
    } catch (e) {
        console.error('superadmin billing feature bindings save error', e)
        return [500, { message: 'Ошибка сохранения привязок модулей' }]
    }
})
